<script>
import { mapGetters } from 'vuex';
import OwnerFilter from '@/V2/components/filters/OwnerFilter';
import CustomerTagsFilter from '@/V2/components/filters/CustomerTagsFilter';
import CustomerDateFilter from '@/V2/components/filters/CustomerDateFilter';
import CustomerStatusesFilter from '@/V2/components/filters/CustomerStatusesFilter';
import CustomerFilter from '@/V2/components/filters/CustomerFilter';
import CustomerComplianceResultsFilter from '@/V2/components/filters/CustomerComplianceResultsFilter';
import CustomerReviewAgentRiskLevelFilter from '@/V2/components/filters/CustomerReviewAgentRiskLevelFilter';
import { iButton } from '@inscribe/signal';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  components: {
    CustomerDateFilter,
    OwnerFilter,
    CustomerFilter,
    CustomerTagsFilter,
    CustomerStatusesFilter,
    CustomerComplianceResultsFilter,
    CustomerReviewAgentRiskLevelFilter,
    iButton,
  },
  props: {
    justifyContent: {
      type: String,
      default: 'start',
      validator: (prop) => ['start', 'center', 'end'].includes(prop),
    },
    dataLoading: {
      type: Boolean,
      default: false,
    },
    hasSelectedFilters: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'isOrgAdvancedUserOrAdmin',
      'canViewBusinessComplianceAgent',
    ]),
  },
  methods: {
    trackFilter(eventName) {
      window.analytics.track(eventName);
    },
    resetFilters() {
      this.$emit('reset-filters');
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMERS_SEARCH_CLICKED, {
        itemName: 'reset-filters-button',
      });
    },
  },
};
</script>

<template>
  <div
    :class="[
      'customer-filters d-flex flex-row justify-content-between',
      `justify-content-${justifyContent}`,
    ]"
  >
    <div class="filters-container d-flex flex-row align-items-center i-gap-3">
      <CustomerDateFilter ref="customerDateFilter" :loading="dataLoading" />
      <CustomerFilter analytics-label="customers-view-customer-filter" />
      <CustomerReviewAgentRiskLevelFilter />
      <CustomerComplianceResultsFilter v-if="canViewBusinessComplianceAgent" />
      <CustomerStatusesFilter
        entity="customers"
        label="Status"
        analytics-label="customers-view-status-filter"
      />
      <OwnerFilter v-if="isOrgAdvancedUserOrAdmin" />
      <CustomerTagsFilter />
    </div>

    <i-button
      :class="{ visible: hasSelectedFilters }"
      class="clear-filters sm"
      text="Clear filters"
      type="neutral"
      subtype="outline"
      size="sm"
      data-dd-action-name="customers-view-clear-filters-button"
      @button-click="() => resetFilters()"
    ></i-button>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.customer-filters {
  .clear-filters.sm {
    height: 36px;
    padding: 10px 14px;
    border: 1px solid var(--border-neutral-subtle);
    border-radius: 9999px;
    @extend .i-text-subheading-3;
    color: var(--text-neutral);
    visibility: hidden;
    opacity: 0;
    transition: all 150ms ease-in-out;

    &.visible {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
